/** Client menu summary row alignment (per menu). */
export const SUMMARY_TEXT_ALIGNS = ["left", "center", "right"];

export function normalizeSummaryTextAlign(v) {
  if (v === "center" || v === "right") return v;
  return "left";
}
